import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ObrasService } from '../../services/obras.service';
import { ProveedoresService } from '../../services/proveedores.service';
import { CuentasPorCobrarService } from '../../services/cuentas-por-cobrar.service';
import { MovimientosObraService } from '../../services/movimientos-obra.service';
import { HelpersService } from '../../services/tools/helpers.service';
import { ConstantsService } from '../../services/constants.service';
import { ModalFacturacionComponent } from './modal-facturacion/modal-facturacion.component';
import { ModalInteresesMoratoriosComponent } from './modal-intereses-moratorios/modal-intereses-moratorios.component';
import { ModalFacturarRecepcionPago } from './modal-facturar-recepcion-pago/modal-facturar-recepcion-pago.component';
import { ModalEliminarCxcComponent } from './modal-eliminar-cxc/modal-eliminar-cxc.component';
import { ModalNotaCreditoComponent } from './modal-nota-credito/modal-nota-credito.component';
import { ModalListadoFacturasPago } from './modal-listado-facturas-pago/modal-listado-facturas-pago.component';

declare var moment;

@Component({
  selector: 'app-reporte-cxc',
  templateUrl: './reporte-cxc.component.html',
  styleUrls: ['./reporte-cxc.component.scss']
})
export class ReporteCXCComponent implements OnInit {

    @ViewChild(ModalFacturacionComponent) modal_facturacion: ModalFacturacionComponent;
    @ViewChild(ModalInteresesMoratoriosComponent) modalInteresesMoratorios: ModalInteresesMoratoriosComponent;
    @ViewChild('modalFacturarRecepcionPago') modalFacturarRecepcionPago: ModalFacturarRecepcionPago;
    @ViewChild('modalListadoFascturasPago') modalListadoFascturasPago: ModalFacturarRecepcionPago;
    @ViewChild('modalEliminarCXC') modalEliminarCXC: ModalEliminarCxcComponent;
    @ViewChild('modalNotaCredito') modalNotaCredito: ModalNotaCreditoComponent;

    //Selector reporte
    public reportes_lista: any[];
    public reporte_actual: any = {};

    //filters
    public obras: any [] = [];
    public obra: any = {};

    public proveedor: any = {};
    public proveedores: any [] = [];
    
    public fechaTermino: any;

    //Palabra clave del buscador: acota por miembro, cliente, concepto u oficina.
    public searchText: string = null;
    public fecha_actual: any;
    
    //helpers
    public loading: boolean = true;
    public loading_obras: boolean = false;
    public loading_proveedores: boolean = false;
    public exportingCSV:boolean = false;

    public cpc: any [] = [];
    errors:any = {};
    public api_url:any="";

    public incluir_cobradas:boolean=false;
    public incluir_canceladas:boolean=false;

    //totales globales del reporte (calculados en backend sobre todo el resultado, no solo la pagina)
    public totales:any = null;

    //paginacion
    paginate:any = {};
    page: number = 1;
    pageSize: number = 10;
    pageAll: number = 100;
    lastPage: any = 1;

    constructor(private router: Router,
        public constant: ConstantsService,
        private movimientosObraService: MovimientosObraService,
        private obrasService: ObrasService,
        private proveedoresService: ProveedoresService,
        private cuentasPorCobrarService: CuentasPorCobrarService,
        private helperService: HelpersService) {
            this.api_url=constant.apiURL;
    }

    ngOnInit() {
        this.getFechaActual();
        this.loadObras();
    }

    mostrarFacturacionModal(cxc){
        this.modal_facturacion.openModal(cxc);
    }

    facturacionModalClosed(reload){
        if(reload){
            this.loadReporte();
        }
    }

    // MAIN SECTIONS FUNCTIONS     
    writePermission() {
        return true;
    }

    canExport() {
        return this.movimientosObraService.canExport();
    }

    exportCSV() {
        this.exportingCSV = true;
        console.log("this.obra.idObras: ",this.obra.idObras);
        this.cuentasPorCobrarService.exportCSV(this.fechaTermino,this.incluir_cobradas,
            this.incluir_canceladas, this.obra.idObras, this.proveedor.idProveedores, )
          .subscribe((response) => {
            this.exportingCSV = false;
          }, (error) => {
            // se resuelven los errores 403 y 500
            this.helperService.httpGlobalError(error);
        });
    }

    getFechaActual() {
        this.movimientosObraService.getFechaActual()
            .subscribe((response) => {
                const content = response.json().content;
                var un_mes_despues = moment(content.fecha).add(1,'M');
                this.fecha_actual = un_mes_despues.format("YYYY-MM-DD");
                this.fechaTermino = un_mes_despues.format("YYYY-MM-DD");
            }, (error) => {
                // se revisan errores 403 - 500
                this.helperService.httpGlobalError(error);

                if (error == 400) {
                console.log('getFechasActual - error 400 ' , error);
                }
            });
    }

    loadObras(){
        this.loading_obras = true;
        this.obrasService.getObratoSelect()
        .subscribe((response) => {
            this.obras = response.json().content;
            this.loadProveedores();
            this.loading_obras = false;
        },error=>{
            alert("ERROR: "+JSON.stringify(error));
            this.loading_obras = false;
        });
    }

    loadProveedores(){
        this.loading_proveedores = true;
        this.proveedoresService.getProveedorestoSelect()
        .subscribe(response => {
            let content = response.json().content;
            this.proveedores = content.proveedores;
            this.loading_proveedores = false;
            this.loadReporte();
        },error=>{
            alert("ERROR: "+JSON.stringify(error));
            this.loading_proveedores = false;
        });
    }

    private loadReporte(){
        this.loading = true;
        this.cuentasPorCobrarService.getReporteCPC(this.page, this.obra.idObras, this.proveedor.idProveedores, this.fechaTermino, this.incluir_cobradas,this.incluir_canceladas,this.searchText)
        .subscribe(response => {
            let content = response.json().content;
            this.cpc = content.data;
            this.paginate = content;
            this.pageSize = content.per_page;
            this.pageAll = content.total;
            this.totales = content.totales;
            this.loading = false;
        },error=>{
            alert("ERROR: "+JSON.stringify(error));
            this.loading = false;
        });
    }

    public pageChanged($event){
        this.page = $event;
        this.loadReporte();
    }

    public changeIncluirCobradas(){
        this.page = 1;
        this.loadReporte();
    }
    public changeIncluirCanceladas(){
        this.page = 1;
        this.loadReporte();
    }
    public filtrarReporte(filtro,$event){
        if(filtro=='inmueble'){
            this.obra=$event;
        }else if(filtro=='miembro'){
            this.proveedor=$event;
        }else if(filtro=='fechaTermino'){
            //Antes decia filtro="fechaTermino" con una sola igualdad: era una asignacion
            //que siempre daba verdadero, asi que cualquier filtro nuevo habria terminado
            //pisando la fecha de termino.
            this.fechaTermino=$event;
        }
        this.page = 1;
        this.loadReporte();
    }

    //Buscar por palabra clave. El API busca en miembro, cliente, concepto y oficina.
    public buscar(){
        this.page = 1;
        this.loadReporte();
    }

    public limpiarBusqueda(){
        this.searchText = null;
        this.buscar();
    }

    //Selector de reporte
    public changeReporte(reporte) {
        if (reporte.id && reporte.id != this.reporte_actual.id) {
          this.router.navigate([reporte.ruta]);
        }
    }

    public return() {
        this.router.navigate(['/catalogo-reportes']);
    }

    public print() {
        setTimeout(() => {
          window.print();
        }, 1200);
    }

    /**
     * Abre una nueva pestania con la vista de "Estado de cuenta" usando los
     * mismos filtros que estan aplicados al reporte. La vista nueva auto-dispara
     * window.print() para que el usuario lo guarde como PDF desde el navegador.
     *
     * Construye la URL manualmente con el hash explicito (#) porque el router
     * usa HashLocationStrategy (useHash: true). Sin el hash, abrir en nueva
     * pestania carga el path como URL real y Angular cae al home.
     */
    public descargarEstadoCuenta() {
        const params: any = {
            idObra: this.obra && this.obra.idObras ? this.obra.idObras : 0,
            idProveedor: this.proveedor && this.proveedor.idProveedores ? this.proveedor.idProveedores : 0,
            fechaTermino: this.fechaTermino || '',
            incluirCobradas: this.incluir_cobradas ? '1' : '0',
            incluirCanceladas: this.incluir_canceladas ? '1' : '0'
        };
        const qs = Object.keys(params)
            .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
            .join('&');
        const url = window.location.origin + '/#/catalogo-reportes/reporte-cuentas-por-cobrar/estado-cuenta?' + qs;
        window.open(url, '_blank');
    }

    public totalBruto(){
        var importe = 0;
        for(var i=0;i<this.cpc.length;i++){
            importe += parseFloat(this.cpc[i].importe_sin_iva);
        }
        return importe;
    }

    public totalNeto(){
        var importe = 0;
        for(var i=0;i<this.cpc.length;i++){
            importe += (parseFloat(this.cpc[i].importe) * parseFloat(this.cpc[i].cantidad));
        }
        return importe;
    }

    public totalInteresesMoratorios(){
        var importe = 0;
        for(var i=0;i<this.cpc.length;i++){
            importe += parseFloat(this.cpc[i].monto_intereses_moratorios_aplicados);
        }
        return importe;
    }

    public totalCobrado(){
        var importe = 0;
        for(var i=0;i<this.cpc.length;i++){
            importe += parseFloat(this.cpc[i].importe_cobrado);
        }
        return importe;
    }

    public totalPorCobrar(){
        var importe = 0;
        for(var i=0;i<this.cpc.length;i++){
            importe += parseFloat(this.cpc[i].total_por_cobrar);
        }
        return importe;
    }

    public mostrarModalInteresesMoratorios(cuenta){
        this.modalInteresesMoratorios.openModal(cuenta);
    }

    public mostrarModalRecepcionPago(cuenta){
        this.modalFacturarRecepcionPago.openModal(cuenta);
    }

    public mostrarModalListadoFacturasPago(cuenta){
        this.modalListadoFascturasPago.openModal(cuenta);
    }
    public mostrarModalEliminarCXC(cuenta){
        this.modalEliminarCXC.openModal(cuenta);
        console.log(cuenta);
       
    }
   
    public onRecepcionPagoFacturado(cuentaPorCobrar: any){
        this.mostrarModalListadoFacturasPago(cuentaPorCobrar);
        //Recargamos el reporte para que muestre el link para ver los recibos de pago
        this.loadReporte();
    }

    public showModalNotaCredito(c){
        console.log("Cuenta: ",c);
        this.modalNotaCredito.openModal(c);
    }

    public debug(c){
        console.log(c);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/reporte-cxc/reporte-cxc.component.ts